import styled from 'vue-styled-components';

const ItemProps = {
    imageSrc: String
};

export const LogoItem = styled('div', ItemProps )`
        width: 100%;
        height: 100%;
        background-image: url(${props => props.imageSrc});
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;  
`

export const PopoverIconWrap  = styled('div', {})`
      margin-left: auto;
      height: 21px;
      position: absolute;
      top: 10px;
      right: 10px;
 `;

export const LogoWrap = styled('div', {})`
        width: 60%;        
        height: 60%;
        `
;


